import { reducer as menuReducer, MOUNT_POINT as MENU_MOUNT_POINT } from './menu';
import { reducer as pagerReducer, MOUNT_POINT as PAGE_MOUNT_POINT } from './page';

const reducers = {
    [MENU_MOUNT_POINT]: menuReducer,
    [PAGE_MOUNT_POINT]: pagerReducer,
};

export default reducers;
